module.exports = __webpack_public_path__ + "ao.2490f4bd.svg";